import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatKeyValue'
})
export class FormatKeyValuePipe implements PipeTransform {
    transform(value: string | null | undefined): string {
        if (!value) {
            return '';
        }

        const pairs = value.split('\n');
        const formattedPairs = pairs.map((pair) => {
            const parts = pair.split(': ');
            if (parts.length === 2) {
                const key = parts[0].trim();
                const val = parts[1].trim();

                return `<strong>${key}:</strong> ${val}`;
            }
            return pair;
        });

        return formattedPairs.join('<br>');
    }
}
